import { useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { Box } from "@mui/material";
import ClientResolutions from "./ClientResolutions";
import AddOrEditClient from "./AddOrEditClient";
import localize from "../../../common/localize";
import ClientEvents from "./ClientEvents";
import useGlobalContext from "../../../hooks/useGlobalContext";
import ScrollablePageTab from "../../dynamicForm/components/ScrollablePageTab";
import ClientBranches from "./ClientBranches";
import ClientBills from "./ClientBills";
import ExpandableView from "../../../components/common/ExpandableView";
import CreatedByText from "../../../components/common/CreatedByText";

export default function ClientFormTabs() {
  const { clientModel } = useGlobalContext();

  const getComponents = () => {
    const result = [
      {
        Name: localize.general_information,
        Component: <AddOrEditClient />,
      },
    ];

    if (clientModel && clientModel.Id >= 0) {
      result.push({
        Name: localize.branches,
        Component: <ClientBranches model={clientModel} />,
      });

      result.push({
        Name: localize.events,
        Component: <ClientEvents clientModelData={clientModel} />,
      });

      result.push({
        Name: localize.bills,
        Component: <ClientBills clientModelData={clientModel} />,
      });

      result.push({
        Name: localize.resolutions,
        Component: <ClientResolutions />,
      });
    }

    return result;
  };

  return (
    <Box className="w-full">
      <ExpandableView components={getComponents()} />

      <CreatedByText entity={clientModel} />
    </Box>
  );
}
